import { render, staticRenderFns } from "./JInput.vue?vue&type=template&id=2c615b60&scoped=true&"
import script from "./JInput.vue?vue&type=script&lang=js&"
export * from "./JInput.vue?vue&type=script&lang=js&"
import style0 from "./JInput.vue?vue&type=style&index=0&id=2c615b60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c615b60",
  null
  
)

export default component.exports